<ng-container *transloco="let t">
  <div class="order-section-item">
    <div class="order-section-item-title">
      {{ t('orderDetails.shippingOption') }}
    </div>
    <div class="order-section-item-value">
      {{ shippingOption().name }}
    </div>
  </div>
  @if (isDelivery()) {
    <div class="order-section-item">
      <div class="order-section-item-title">{{ t('orderDetails.address') }}</div>
      <div class="order-section-item-value">
        @if (addressLink()) {
          <a class="ui-help-link" [href]="addressLink()" target="_blank">
            {{ shippingAddress() }}
          </a>
        } @else {
          <span>{{ shippingAddress() }}</span>
        }
      </div>
    </div>
    @if (addressHints()) {
      <div class="order-section-item">
        <div class="order-section-item-title">
          {{ t('orderDetails.references') }}
        </div>
        <div class="order-section-item-value">
          {{ addressHints() }}
        </div>
      </div>
    }
    @if (displayShippingEstimate()) {
      @let shippingEstimateValue = shippingEstimate();
      @let shippingOrderValue = shippingOrder();

      @if (shippingEstimateValue && !shippingOrderValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">Envío</div>
          <div class="order-section-item-value">
            <pxw-button
              (click)="
                shippingEstimateValue.offerId ? confirmShipping.emit() : createShipping.emit()
              "
              [loading]="isShippingRequestInProgress()"
              color="yellow"
              display="inline"
              size="sm"
              [rounded]="true"
            >
              <pxw-icon icon="shipping" />
              {{ shippingButtonText() }}
            </pxw-button>
          </div>
        </div>
      }

      @if (shippingEstimateValue && shippingEstimateValue?.error) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.shippingError') }}
          </div>
          <div class="order-section-item-value">
            {{ shippingEstimateValue.error }}
          </div>
        </div>
      }

      @if (shippingOrderValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.confirmationCode') }}
          </div>
          <div class="order-section-item-value">
            {{ shippingOrderValue.shippingId }}
          </div>
        </div>
      }

      @if (shippingEstimateValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.providerName') }}
          </div>
          <div class="order-section-item-value">
            <img
              [src]="
                '/assets/images/integration-providers/' +
                shippingEstimateValue.providerName +
                '.webp'
              "
              alt="{{ shippingEstimateValue.providerName }}"
              class="provider-logo"
            />
          </div>
        </div>
      }

      @if (shippingOrderValue) {
        <div class="order-section-item">
          <div class="order-section-item-title">
            {{ t('orderDetails.shippingStatus') }}
          </div>
          <div class="order-section-item-value">
            <pxw-order-shipping-status 
              [status]="shippingOrderValue.status" 
              [providerName]="shippingOrderValue.providerName" 
            />
          </div>
        </div>

        @if (shippingOrderValue.estimatedDeliveryTime) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.estimatedDeliveryTime') }}
            </div>
            <div class="order-section-item-value">
              {{ shippingOrderValue.estimatedDeliveryTime | date: 'dd/MM/yyyy - HH:mm' }}hs
            </div>
          </div>
        }
        @if (shippingOrderValue.status !== 'CANCELLED' && shippingOrderValue.trackingUrl) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.trackingUrl') }}
            </div>
            <div class="order-section-item-value">
              <a [href]="shippingOrderValue.trackingUrl" class="ui-help-link" target="_blank">
                {{ t('orderDetails.viewTracking') }}
              </a>
            </div>
          </div>
        }
        @if (shippingOrderValue.supportUrl) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.supportUrl') }}
            </div>
            <div class="order-section-item-value">
              <a [href]="shippingOrderValue.supportUrl" target="_blank" class="ui-help-link">
                {{ t('orderDetails.contactSupport') }}
              </a>
            </div>
          </div>
        }
        @if (shippingOrderValue.additionalInfo) {
          <div class="order-section-item">
            <div class="order-section-item-title">
              {{ t('orderDetails.additionalInfo') }}
            </div>
            <div class="order-section-item-value">
              {{ shippingOrderValue.additionalInfo }}
            </div>
          </div>
        }
        @if (shippingOrderValue.status !== 'CANCELLED' && shippingOrderValue.providerName !== 'correoargentino') {
          <div
            class="order-section-item"
            [ngClass]="{
              'order-shipping-cancel-alert': !canCancelShipping(),
            }"
          >
            <div class="order-section-item-title">
              {{ t('orderDetails.cancelShippingText') }}
            </div>
            @if (canCancelShipping()) {
              <pxw-button
                (click)="cancelShipping.emit()"
                [loading]="isShippingRequestInProgress()"
                color="yellow"
                display="inline"
                size="sm"
                [rounded]="true"
              >
                {{ t('orderDetails.cancelShipping') }}
              </pxw-button>
            } @else {
              <pxw-alert type="danger" display="inline-block" size="sm">
                {{ t('orderDetails.cannotCancel') }}
              </pxw-alert>
            }
          </div>
        }
      }
    }
  }
  @if (tableNumber()) {
    <div class="order-section-item">
      <div class="order-section-item-title">{{ t('orderDetails.table') }}</div>
      <div class="order-section-item-value">
        {{ tableNumber() }}
      </div>
    </div>
  }
</ng-container>
